module.exports = __webpack_public_path__ + "img/provision-aridos.2c081ee6.png";